import logger from '@/domains/core/observability/logger';
import { getAppSetting } from '@/domains/core/settings/appSettings';

import type {
  RawStaticSuggestionItem,
  StaticSuggestionType,
  Suggestion,
} from '../interfaces/suggestions';
import { formatSuggestion } from './formatSuggestion';

// Format Vault suggestions to display
export const createStaticSuggestions = ({
  type,
  termQuery = '',
  highlight = false,
  maxLength,
}: {
  type: StaticSuggestionType;
  termQuery?: string;
  highlight?: boolean;
  maxLength?: number;
}) => {
  try {
    const suggestions: RawStaticSuggestionItem[] = JSON.parse(
      getAppSetting('SEARCHBAR_EMPTYSEARCH_SUGGESTIONS'),
    )[type];

    if (!suggestions || Object.keys(suggestions).length === 0) return [];

    return suggestions?.slice(0, maxLength).map(
      ({ objectID, query }: RawStaticSuggestionItem) =>
        formatSuggestion({
          name: query,
          objectID,
          termQuery,
          type,
          highlight,
        }) as Suggestion,
    );
  } catch (error) {
    logger.error(error);

    return [];
  }
};
